export default {
    //未读消息数
    getNoticenum () {
        return new Promise((resolve, reject) => {
            axios.get('/api/notice/nums', {
                params:{
                    media_id:6
                }
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //评论消息
    getComments (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/notice/comments', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //问答消息
    getAnswer (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/notice/asks',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //系统消息
    getSystem(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/notice/system',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //删除
    delMessage(id){
       return new Promise((resolve, reject) => {
        axios.delete('/api/notice/'+ id +'/delete')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
   },
   getCommentsList(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/my/comments',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
}
}